import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root",
})
export class HandleChangeService {
    hasComponentChangedObject: { [url: string]: boolean } = {};

    constructor() { }

    handleChange(url: string, value: boolean) {
        this.hasComponentChangedObject[url] = value;
    }

    getComponentChanges(url: string) {
        return this.hasComponentChangedObject[url];
    }
}
